export default __webpack_public_path__ + "static/media/product-11.a5600b8d.jpg";